module.exports = __webpack_public_path__ + "img/bg.574c3abc.jpg";